import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type useUserActivities_query$data,
  type useUserActivities_query$key
} from '@/__generated__/useUserActivities_query.graphql'
import { type useUserActivitiesMutation } from '@/__generated__/useUserActivitiesMutation.graphql'

export const useUserActivities = (
  queryRef?: useUserActivities_query$key | null | undefined
): [string[], (activityIds: string[]) => Promise<useUserActivities_query$data>, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment useUserActivities_query on Query {
        currentUser {
          userActivities(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {
            nodes {
              activityId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.userActivities.nodes, 'activityId'),
    [queryData?.currentUser?.userActivities.nodes]
  )
  const [commit, isPending] = useMutation<useUserActivitiesMutation>(graphql`
    mutation useUserActivitiesMutation($input: UpdateUserActivitiesInput!) {
      updateUserActivities(input: $input) {
        query {
          ...useUserActivities_query
        }
      }
    }
  `)

  const commitAsync = useCallback<(activityIds: string[]) => Promise<useUserActivities_query$data>>(
    (activityIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              activityIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
